export default {
  // 搜索選擇器
  transactionDirection: "交易方向",
  currency: "幣種",
  pleaseSelect: "請選擇",
  totalAmount: "總數量",
  transactionCount: "交易次數",
  minAmount: "最小數量",
  maxAmount: "最大數量",
  maxAmountWarning: "最大數量需≥最小數量",

  // 按鈕
  reset: "重置",
  query: "查詢",

  // 數據統計
  totalData: "共計{count}條數據",

  // 加載
  loading: "拼命加載中",

  // 表格列
  direction: "交易方向",
  count: "交易次數",
  fiatCurrency: "法幣",
  totalMoney: "總金額",

  // 交易方向
  buy: "買入",
  sell: "賣出",
  unknown: "未知",

  // 空狀態
  noOtcData: "當前調證文件中未解析到OTC交易數據",

  // 下載
  downloadDetails: "下載數據明細",
};
